module.exports = __webpack_public_path__ + "catalog/items/umbrella-stand/bronze-texture.jpg";